<template>
  <div class="page" v-loading="loading">
    <el-form ref="form" :model="form" label-width="100px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="仓库名" prop="stockName">
            <el-input v-model="form.stockName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button type="primary" @click="getData">查询</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-form-item label-width="0">
        <toolbar :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
      </el-form-item> -->
    </el-form>
    <el-table :data="tableData" border style="width: 100%;" :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }">
      <el-table-column label="id" prop="id" min-width="200"></el-table-column>
      <el-table-column label="仓库名" prop="stockName" min-width="200"></el-table-column>
      <!-- <el-table-column label="仓库所属供应商" prop="supName" width="200"></el-table-column>
      <el-table-column label="发货区域" prop="deliverAreaName"></el-table-column> -->
      <!-- <el-table-column label="操作" width="430">
        <template slot-scope="scope">
          <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"
            @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}
          </el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="form.pageIndex" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="form.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>
    <el-dialog :title="addParams.id ? '编辑仓库' : '新建仓库'" :visible.sync="addVisible" width="50%" v-loading="loading">
      <el-form :model="addParams" ref="addParams" label-width="100px">
        <el-form-item label="仓库名" prop="stockName" :rules="[
          { required: true, message: '请输入', trigger: 'blur' },
        ]">
          <el-input v-model="addParams.stockName"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="addConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="复制" :visible.sync="copyVisible" width="50%" v-loading="loading">
      <el-form :model="copyParams" ref="copyParams" label-width="100px">
        <el-form-item label="仓库名" prop="stockName" :rules="[
          { required: true, message: '请输入', trigger: 'blur' },
        ]">
          <el-input v-model="copyParams.stockName"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="copyVisible = false">取 消</el-button>
        <el-button type="primary" @click="copyConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="发货区域配置" :visible.sync="areaVisible" width="50%" :close-on-click-modal="false">
      <AreaSetting :id="areaParams.id" v-if="areaVisible" :areaStr="areaParams.deliverArea"></AreaSetting>
    </el-dialog>
  </div>
</template>

<script>
import {
  KSAXApiRequest,
  GetAllReseller
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import AreaSetting from "./components/AreaSetting.vue";

export default {
  components: { Toolbar, AreaSetting },
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      buttonList_toolBar: [],
      buttonList_table: [],
      form: {
        level: 1,
        supId: null,
        parentId: null,
        stockName: null,
        pageIndex: 1,
        pageSize: 10
      },
      addVisible: false,
      addParams: {},
      copyVisible: false,
      copyParams: {},
      areaVisible: false,
      areaParams: {},
    };
  },
  created() {
    this.getAllReseller()
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    var buttonList = getButtonList(this.$route.path, routers) || []
    this.buttonList_toolBar = buttonList.filter(item => item.buttonShow === 10);
    this.buttonList_table = buttonList.filter(item => item.buttonShow === 20);
  },
  methods: {
    getAllReseller() {
      GetAllReseller({ SkipCount: 0, MaxResultCount: 10 }).then(res => {
        if (res.data.success) {
          this.form.supId = res.data.result.items[0].remoteKey
          this.queryData()
        }
      })
    },
    queryData() {
      this.loading = true
      KSAXApiRequest({
        path: 'Product_MultistageStock/List',
        parmsJson: this.form
      }).then(res => {
        if (res.data.success) {
          this.tableData = res.data.response.data || []
          this.total = res.data.response.dataCount
        } else {
          this.$message.error(res.data.msg)
        }
        setTimeout(() => {
          this.loading = false
        }, 500)
      })
    },
    callFunction(item) {
      this[item.buttonFunc](item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    getData() {
      this.form.pageIndex = 1
      this.form.pageSize = 10
      this.queryData()
    },
    handleSizeChange(value) {
      this.form.pageSize = value
      this.queryData()
    },
    handleCurrentChange(value) {
      this.form.pageIndex = value
      this.queryData()
    },
    resetForm() {
      this.$refs["form"].resetFields();
      this.getData()
    },
    handleAdd() {
      this.addParams = {
        level: 1,
        stockName: null,
        supIds: this.form.supId,
      }
      this.addVisible = true
    },
    addConfirm() {
      this.$refs.addParams.validate((valid) => {
        if (valid) {
          this.loading = true
          let path = this.addParams.id ? "Product_MultistageStock/Update" : 'Product_MultistageStock/Add'
          KSAXApiRequest({
            path,
            parmsJson: this.addParams,
          }).then(res => {
            this.loading = false
            if (res.data.success) {
              this.$message.success(res.data.msg)
              this.queryData()
              this.addVisible = false
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      });
    },
    exportList() {
      KSAXApiRequest({
        path: 'Product_MultistageStock/ExportList',
        parmsJson: this.form
      }).then(res => {
        if (res.data.success) {
          this.$message.success("操作成功，请点击下载中心查看下载结果");
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    areaConfig(item, index, row) {
      this.areaParams = {
        id: row.id,
        deliverArea: row.deliverArea
      }
      this.areaVisible = true
    },
    stock2(item, index, row) {
      this.$router.push(`/MultistageStoc/Config2?id=${row.id}&supId=${row.supIds}`)
    },
    handleDelete(item, index, row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        KSAXApiRequest({
          path: "Product_MultistageStock/Delete",
          parmsJson: { id: row.id },
        }).then(res => {
          this.loading = false
          if (res.data.success) {
            this.$message.success(res.data.msg)
            this.queryData()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    handleCopy(item, index, row) {
      this.copyParams = {
        supIds: row.supIds,
        stockId: row.id,
        stockName: ""
      }
      this.copyVisible = true
    },
    handleEdit(item, index, row) {
      this.addParams = {
        id: row.id,
        stockName: row.stockName,
        supIds: row.supIds
      }
      this.addVisible = true
    },
    copyConfirm() {
      this.$refs.copyParams.validate((valid) => {
        if (valid) {
          this.loading = true
          KSAXApiRequest({
            path: "Product_MultistageStock/CopyMultistageStock",
            parmsJson: this.copyParams,
          }).then(res => {
            this.loading = false
            if (res.data.success) {
              this.$message.success(res.data.msg)
              this.queryData()
              this.copyVisible = false
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      });
    }
  },
};
</script>

<style scoped></style>
